import { render, staticRenderFns } from "./NotesModule.vue?vue&type=template&id=5c4918bb&scoped=true&"
import script from "./NotesModule.vue?vue&type=script&lang=js&"
export * from "./NotesModule.vue?vue&type=script&lang=js&"
import style0 from "./NotesModule.vue?vue&type=style&index=0&id=5c4918bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4918bb",
  null
  
)

export default component.exports